const getApiUrl = () => {
  if (process.env.REACT_APP_BASE_URL) {
    return process.env.REACT_APP_BASE_URL;
  }
  const { host } = window.location;
  if (host.indexOf("localhost") > -1) {
    return "http://localhost:8080";
  } else if (host.indexOf(".qa") > -1) {
    return "https://api.qa.tenantport.com";
  } else {
    return "https://api.tenantport.com";
  }
};
export const configs = {
  auth0_domain: "auth.tenantport.com",
  api_audience: "http://resident-portal-API",
  clientId: "8Saw8xEXqQ9UezAv7Ff2wQD8g2nzCQKQ",
  base_url: getApiUrl(),
  grid_data_limit: 2000,
  BASE_CURRENCY: "$",
  FULLSTORY_ORG_ID: "o-24DGFP-na1",
  proofup_url: "https://api.proofup.com/api",
  // HOTMA net-family-assets "imputation threshold". Households at or below this
  // total self-certify their assets (no document upload); above it they must
  // upload full asset verification. HUD inflation-adjusts this yearly from the
  // $50,000 baseline — current value is CY2026 ($52,787). Update per the annual
  // HUD notice. PASSBOOK rate is applied to impute asset income above the
  // threshold (greater of actual vs. cash value x rate).
  HOTMA_ASSET_THRESHOLD: 52787,
  HOTMA_PASSBOOK_RATE: 0.004,
};
